// Frame timings shared by the server-rendered showcase sections and the lazily
// loaded Remotion compositions. Keep this file free of `remotion` imports: the
// static homepage bundle reads it to map scroll positions and chapter buttons.

export const SHOWCASE_FPS = 30;

export const INTRO_REEL = {
  id: 'intro',
  width: 1080,
  height: 1920,
  durationInFrames: 780,
  beats: [
    { id: 'hook', from: 0, to: 110, hold: 98 },
    { id: 'drop', from: 110, to: 230, hold: 218 },
    { id: 'read', from: 230, to: 370, hold: 356 },
    { id: 'rank', from: 370, to: 490, hold: 476 },
    { id: 'fanout', from: 490, to: 600, hold: 588 },
    { id: 'export', from: 600, to: 700, hold: 688 },
    { id: 'end', from: 700, to: 780, hold: 776 }
  ]
};

// Auto-Translate targets in Metadata Studio (MetadataPanel language select).
export const TRANSLATION_TARGETS = ['tr', 'de', 'fr', 'es', 'it', 'pt', 'ru', 'ja', 'zh', 'ar'];

export const LANGUAGE_MORPH = {
  id: 'languages',
  width: 1600,
  height: 812,
  intro: 24,
  segment: 72,
  durationInFrames: 24 + TRANSLATION_TARGETS.length * 72
};

export const FEATURE_REEL_IDS = ['keywordIntel', 'bulkEdit', 'video', 'vectorizer'];

export const FEATURE_REEL = {
  width: 1080,
  height: 1920,
  durationInFrames: 300,
  hold: 252
};

// The visitor's own language leads when Metadata Studio can translate into it.
export const orderTranslationTargets = (language) => {
  const normalized = String(language || '').toLowerCase();
  if (!TRANSLATION_TARGETS.includes(normalized)) return [...TRANSLATION_TARGETS];
  return [normalized, ...TRANSLATION_TARGETS.filter((code) => code !== normalized)];
};

export const getLanguageSegment = (index) => {
  const from = LANGUAGE_MORPH.intro + index * LANGUAGE_MORPH.segment;
  return { from, to: from + LANGUAGE_MORPH.segment, hold: from + LANGUAGE_MORPH.segment - 10 };
};

export const getIntroBeatIndex = (frame) => {
  const beats = INTRO_REEL.beats;
  for (let index = beats.length - 1; index >= 0; index -= 1) {
    if (frame >= beats[index].from) return index;
  }
  return 0;
};

export const clampFrame = (frame, durationInFrames) => (
  Math.min(durationInFrames - 1, Math.max(0, Math.round(frame)))
);
